import { render, staticRenderFns } from "./indexVOD.vue?vue&type=template&id=f686d6b4&scoped=true"
import script from "./indexVOD.vue?vue&type=script&lang=js"
export * from "./indexVOD.vue?vue&type=script&lang=js"
import style0 from "./indexVOD.vue?vue&type=style&index=0&id=f686d6b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f686d6b4",
  null
  
)

export default component.exports